import { render, staticRenderFns } from "./Colorpicker.vue?vue&type=template&id=0a6aabbc&scoped=true&"
import script from "./Colorpicker.vue?vue&type=script&lang=js&"
export * from "./Colorpicker.vue?vue&type=script&lang=js&"
import style0 from "./Colorpicker.scss?vue&type=style&index=0&id=0a6aabbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6aabbc",
  null
  
)

export default component.exports